import { render, staticRenderFns } from "./number_input.vue?vue&type=template&id=2bda3d27&scoped=true&lang=pug"
import script from "./number_input.vue?vue&type=script&lang=js"
export * from "./number_input.vue?vue&type=script&lang=js"
import style0 from "./number_input.vue?vue&type=style&index=0&id=2bda3d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda3d27",
  null
  
)

export default component.exports